module.exports = __webpack_public_path__ + "static/info-apoio-mobile-61577b76dae96848668f616aa4051967.png";